import { saveAs } from "file-saver";
import {
  getGroupName,
  getSelectedPeriod,
} from "../../../../services/GroupContext";
import { processDateJS } from "../../../../utils/dateProcessor";
import { getAllocatedReactivationsExcelData } from "../fullReturnSections/allocatedReactivations";
import { getAllocatedRestrictionsExcelData } from "../fullReturnSections/allocatedRestrictions";
import { getGroupLevelAmountsExcelData } from "../fullReturnSections/groupLevelAmounts";
import { getGroupLevelElectionsExcelData } from "../fullReturnSections/groupLevelElections";
import { getGroupPeriodExcelData } from "../fullReturnSections/groupPeriod";
import { getUKGroupCompaniesExcelData } from "../fullReturnSections/ukGroupCompanies";
import { generateCellsRange, styleCells } from "./fullReturnOutputUtils";
import { getFullReturnExcelData } from "./metrics";
const ExcelJS = require("exceljs");

export const sheetStylesConfig = [
  {
    name: "(1)_Group,_period,_return_type_",
    getRows: getGroupPeriodExcelData,
    styles: {
      boldCells: [
        "B2",
        "B7",
        "B11",
        "B15",
        "B18",
        "B24",
        "B29",
        "B33",
        "B37",
        "B40",
        "B46",
        "C24",
        "C29",
      ],
      dateCells: ["D12", "D13"],
      colWidths: {
        1: 2,
        2: 90,
        3: 90,
        4: 60,
        5: 2,
      },
      rowHeights: {
        35: 100,
        38: 100,
      },
      alignments: {
        B4: { vertical: "top", horizontal: "left" },
        B35: { vertical: "top", horizontal: "left", wrapText: true },
        B38: { vertical: "top", horizontal: "left", wrapText: true },
      },
      singleCellBorders: ["B2", "B4", "B7", "B9"],
      squareBorders: [
        { start: "B11", end: "D13" },
        { start: "B15", end: "D16" },
        { start: "B18", end: "D22" },
        { start: "B24", end: "C27" },
        { start: "B29", end: "C31" },
        { start: "B33", end: "D35" },
        { start: "B37", end: "D38" },
        { start: "B40", end: "D44" },
        { start: "B46", end: "C47" },
      ],
      removedBorders: {
        B12: ["right", "bottom"],
        B13: ["right", "top"],
        C12: ["left", "bottom"],
        C13: ["left", "top"],
      },
      mergedCells: [
        "B2:D2",
        "B4:D5",
        "B7:C7",
        "B9:D9",
        "B11:D11",
        "B33:D33",
        "B37:D37",
        "B40:D40",
        "B46:C46",
      ],
      borderRightFixes: ["B11", "B33", "B37", "B40", "B46"],
      colouredCells: {
        FFC0C0C0: [
          "B7",
          "C7",
          "B9",
          "C9",
          "D9",
          "B11",
          "C11",
          "D11",
          "B15",
          "B18",
          "B24",
          "B33",
          "C33",
          "D33",
          "B37",
          "C37",
          "D37",
          "B40",
          "C40",
          "D40",
          "B46",
          "C46",
        ],
        FFFFFF99: [
          "B2",
          "C2",
          "D2",
          "B4",
          "B22",
          "B27",
          "C27",
          "B34",
          "C34",
          "D34",
          "C47",
        ],
        FFFFFFCC: [
          "D12",
          "D13",
          "D15",
          "D16",
          "D18",
          "D19",
          "D20",
          "D21",
          "D22",
          "C25",
          "C26",
          "C30",
          "C31",
          "B35",
          "C35",
          "D35",
          "B38",
          "C38",
          "D38",
          "C42",
          "D42",
          "C43",
          "D43",
          "C44",
          "D44",
          "B47",
        ],
      },
    },
  },
  {
    name: "(2)_Group_level_elections",
    getRows: getGroupLevelElectionsExcelData,
    styles: {
      boldCells: [
        "B2",
        "B4",
        "B6",
        "B7",
        "B8",
        "B10",
        "B12",
        "B21",
        "B25",
        "B29",
        "B33",
        "C12",
        "D12",
      ],
      colWidths: {
        1: 2,
        2: 165,
        3: 20,
        4: 20,
        5: 2,
      },
      rowHeights: {
        9: 2,
        23: 80,
        27: 80,
        31: 80,
      },
      alignments: {
        B23: { vertical: "top", horizontal: "left" },
        B27: { vertical: "top", horizontal: "left" },
        B31: { vertical: "top", horizontal: "left", wrapText: true },
      },
      horizontallyAlignedCells: [
        "C13",
        "C14",
        "C15",
        "C16",
        "C17",
        "C18",
        "D13",
        "D14",
        "D15",
        "D16",
        "D17",
        "D18",
      ],
      singleCellBorders: ["B2", "B4"],
      squareBorders: [
        { start: "B6", end: "D10" },
        { start: "B12", end: "D18" },
        { start: "B21", end: "D23" },
        { start: "B25", end: "D27" },
        { start: "B29", end: "D31" },
        { start: "B33", end: "C34" },
      ],
      mergedCells: [
        "B2:D2",
        "B4:D4",
        "B6:D6",
        "C7:D7",
        "C8:D8",
        "C10:D10",
        "B21:D21",
        "B22:D22",
        "B23:D23",
        "B25:D25",
        "B26:D26",
        "B27:D27",
        "B29:D29",
        "B30:D30",
        "B31:D31",
        "B33:C33",
      ],
      borderRightFixes: [
        "B6",
        "C7",
        "C8",
        "C10",
        "B21",
        "B22",
        "B23",
        "B25",
        "B26",
        "B27",
        "B29",
        "B30",
        "B31",
        "B33",
      ],
      colouredCells: {
        FFC0C0C0: [
          "B2",
          "C2",
          "D2",
          "B4",
          "C4",
          "D4",
          "B7",
          "B8",
          "B9",
          "B10",
          "B12",
          "B21",
          "B25",
          "B29",
          "B33",
          "C21",
          "D21",
          "C25",
          "D25",
          "C29",
          "D29",
          "C33",
        ],
        FFFFFF99: ["B6", "C6", "D6", "C34"],
        FFFFFFCC: [
          "C7",
          "D7",
          "C8",
          "D8",
          "C9",
          "D9",
          "C10",
          "D10",
          "C13",
          "D13",
          "C14",
          "D14",
          "C15",
          "C16",
          "C17",
          "D17",
          "C18",
          "B23",
          "C23",
          "D23",
          "B27",
          "C27",
          "D27",
          "B31",
          "C31",
          "D31",
          "B34",
        ],
      },
    },
  },
  {
    name: "(3)_UK_group_companies_",
    getRows: getUKGroupCompaniesExcelData,
    styles: {
      boldCells: [
        "B2",
        "B4",
        "B7",
        "B8",
        "B9",
        "B10",
        "C12",
        "C14",
        "D14",
        "E14",
        "F14",
        "D15",
        "E15",
        "F15",
        "H12",
        "H13",
        "H14",
        "I14",
        "J14",
        "C320",
        "H317",
        "H318",
        "I318",
        "H321",
        "I321",
        "J321",
      ],
      colWidths: {
        1: 2,
        2: 8,
        3: 115,
        4: 20,
        5: 15,
        6: 15,
        7: 5,
        8: 36,
        9: 36,
        10: 36,
        11: 2,
      },
      rowHeights: {
        1: 3,
        3: 5,
        5: 5,
        11: 5,
        14: 40,
      },
      centeredCols: ["B", "D", "E", "F"],
      alignedLeftRows: [2, 4, 6, 7, 8, 9, 10, 320],
      wrappedTextCells: ["B14", "E14"],
      singleCellBorders: ["B2", "B4"],
      squareBorders: [
        { start: "B6", end: "F10" },
        { start: "B12", end: "F13" },
        { start: "H12", end: "J13" },
        { start: "B14", end: "F315" },
        { start: "H14", end: "J315" },
        { start: "C320", end: "E321" },
        { start: "H317", end: "J322" },
      ],
      removedBorders: {
        H12: ["bottom"],
        H13: ["top"],
      },
      mergedCells: [
        "B2:J2",
        "B4:J4",
        "B6:F6",
        "B7:C7",
        "B8:C8",
        "B9:C9",
        "B10:C10",
        "D7:F7",
        "D8:F8",
        "D9:F9",
        "D10:F10",
        "C12:F13",
        "B12:B13",
        "H12:J12",
        "H13:J13",
        "C320:E320",
        "H317:J317",
      ],
      borderRightFixes: [
        "B6",
        "D7",
        "D8",
        "D9",
        "D10",
        "C12",
        "C13",
        "H12",
        "H13",
        "C320",
        "H317",
      ],
      calculations: true,
      numberColumns: {
        columns: ["H", "I", "J"],
        startRow: 16,
        numOfRows: 307,
      },
      colouredCells: {
        FFC0C0C0: [
          "B2",
          "B4",
          "B7",
          "B8",
          "B9",
          "B10",
          "B12",
          "C12",
          "H12",
          "H13",
          "C320",
          "D320",
          "E320",
          "H317",
          "I317",
          "J317",
        ],
        FFFFFF99: [
          "B6",
          "C15",
          "D15",
          "E15",
          "F15",
          "H15",
          "I15",
          "J15",
          "C321",
        ],
        FFFFFFCC: [
          ...generateCellsRange(16, 300, ["C", "D", "E", "F"]),
          "E321",
        ],
        FFCCFFFF: [
          ...generateCellsRange(15, 301, ["H", "I", "J"]),
          "D321",
          "H319",
          "I319",
          "H322",
          "I322",
          "J322",
        ],
      },
    },
  },
  {
    name: "(4)_Group_level_amounts_",
    getRows: getGroupLevelAmountsExcelData,
    styles: {
      boldCells: [
        "B2",
        "B4",
        "B7",
        "B8",
        "B9",
        "B10",
        "B12",
        "B13",
        "B15",
        "C15",
        "C36",
      ],
      colWidths: {
        1: 2,
        2: 105,
        3: 50,
        4: 5,
      },
      rowHeights: {
        1: 5,
        30: 5,
      },
      alignments: {
        C17: { horizontal: "right" },
        C19: { horizontal: "right" },
      },
      numberCells: [
        "C18",
        "C20",
        "C22",
        "C23",
        "C24",
        "C25",
        "C26",
        "C27",
        "C29",
        "C31",
        "C32",
        "C33",
      ],
      percentageCells: ["C34"],
      singleCellBorders: ["B2", "B4"],
      squareBorders: [
        { start: "B6", end: "C10" },
        { start: "B12", end: "C13" },
        { start: "B15", end: "C34" },
        { start: "B36", end: "C38" },
      ],
      removedBorders: {
        B12: ["bottom"],
        B13: ["top"],
      },
      mergedCells: ["B2:C2", "B4:C4", "B6:C6", "B12:C12", "B13:C13", "B36:C36"],
      borderRightFixes: ["B6", "B12", "B13", "B36"],
      calculations: true,
      colouredCells: {
        FFC0C0C0: ["B2", "B4", "B7", "B8", "B9", "B10", "B15", "C15", "B36"],
        FFFFFF99: ["B6", "B12", "B13", "B38", "C38"],
        FFFFFFCC: ["C17", "C19"],
        FFE0FFFF: [
          "C18",
          "C20",
          "C22",
          "C23",
          "C24",
          "C25",
          "C26",
          "C27",
          "C29",
          "C32",
          "C33",
          "C34",
          "B37",
          "C37",
        ],
      },
    },
  },
  {
    name: "(5)_Allocated_restrictions_",
    getRows: getAllocatedRestrictionsExcelData,
    styles: {
      boldCells: [
        "B2",
        "B4",
        "B7",
        "B8",
        "B9",
        "B10",
        "B12",
        "C12",
        "D12",
        "E12",
        "F12",
        "G12",
        "H12",
        "I12",
        "J12",
        "E13",
        "F13",
        "G13",
        "H13",
        "I13",
        "J13",
        "B316",
        "B317",
        "B319",
      ],
      colWidths: {
        1: 2,
        2: 7,
        3: 84,
        4: 17,
        5: 26,
        6: 26,
        7: 26,
        8: 32,
        9: 32,
        10: 32,
      },
      rowHeights: {
        1: 5,
        3: 5,
        5: 5,
        11: 5,
        315: 5,
        318: 5,
      },
      wrappedTextCells: ["B12", "D12"],
      singleCellBorders: ["B2", "B4"],
      squareBorders: [
        { start: "B6", end: "E10" },
        { start: "B12", end: "J317" },
        { start: "B319", end: "F320" },
      ],
      removedBorders: {
        B13: ["bottom"],
        B14: ["top"],
        C13: ["right", "bottom"],
        C14: ["right", "top"],
        D13: ["left", "bottom"],
        D14: ["left", "top"],
      },
      mergedCells: [
        "B2:J2",
        "B4:J4",
        "B6:E6",
        "B7:C7",
        "B8:C8",
        "B9:C9",
        "B10:C10",
        "D7:E7",
        "D8:E8",
        "D9:E9",
        "D10:E10",
        "H14:J14",
        "B319:F319",
      ],
      borderRightFixes: ["B6", "D7", "D8", "D9", "D10", "H14", "B319"],
      calculations: true,
      numberColumns: {
        columns: ["H", "I", "J"],
        startRow: 15,
        numOfRows: 303,
      },
      colouredCells: {
        FFC0C0C0: [
          "B2",
          "B4",
          "B7",
          "B8",
          "B9",
          "B10",
          "B12",
          "C12",
          "D12",
          "E12",
          "F12",
          "G12",
          "H12",
          "I12",
          "J12",
          "E13",
          "F13",
          "G13",
          "H13",
          "I13",
          "J13",
          "B319",
        ],
        FFFFFF99: [
          "B6",
          "C13",
          "D13",
          "C14",
          "D14",
          "H14",
          "I14",
          "J14",
          "I317",
          "F320",
          "E14",
          "F14",
          "G14",
        ],
        FFFFFFCC: [
          ...generateCellsRange(15, 300, ["E", "F", "G"]),
          "B320",
          "C320",
        ],
        FFCCFFFF: [
          ...generateCellsRange(15, 300, ["H", "I", "J"]),
          "J316",
          "J317",
          "D320",
          "E320",
        ],
      },
    },
  },
  {
    name: "(6)_Allocated_reactivations",
    getRows: getAllocatedReactivationsExcelData,
    styles: {
      boldCells: [
        "B2",
        "B4",
        "B7",
        "B8",
        "B9",
        "B10",
        "B12",
        "C12",
        "D12",
        "E12",
        "B315",
        "B316",
        "B318",
      ],
      colWidths: {
        1: 2,
        2: 7,
        3: 107,
        4: 52,
        5: 52,
        6: 10,
      },
      rowHeights: {
        1: 5,
        3: 5,
        5: 5,
        11: 5,
        314: 5,
        317: 5,
      },
      wrappedTextCells: ["B12", "D12", "E12"],
      singleCellBorders: ["B2", "B4"],
      squareBorders: [
        { start: "B6", end: "D10" },
        { start: "B12", end: "E316" },
        { start: "B318", end: "E319" },
      ],
      mergedCells: [
        "B2:E2",
        "B4:E4",
        "B6:D6",
        "B7:C7",
        "B8:C8",
        "B9:C9",
        "B10:C10",
        "B315:C315",
        "B316:C316",
        "B318:E318",
      ],
      borderRightFixes: ["B6", "B318"],
      calculations: true,
      numberColumns: {
        columns: ["D", "E"],
        startRow: 14,
        numOfRows: 303,
      },
      colouredCells: {
        FFC0C0C0: ["B2", "B4", "B7", "B8", "B9", "B10", "B318"],
        FFFFFFCC: ["B319", "C319"],
        FFFFFF99: ["B6", "B13", "C13", "D13", "E13", "D316", "E319"],
        FFCCFFFF: [
          "E315",
          "E316",
          "D319",
          ...generateCellsRange(14, 300, ["D", "E"]),
        ],
      },
    },
  },
];

export async function downloadFullReturn(savedData) {
  const excelData = getFullReturnExcelData(savedData);
  const workbook = new ExcelJS.Workbook();

  sheetStylesConfig.forEach((config) => {
    const worksheet = workbook.addWorksheet(config.name);

    const rows = config.getRows(excelData);
    worksheet.addRows(rows);

    styleCells(worksheet, config);
  });

  await save(workbook);
}

const save = async (workbook) => {
  const selectedPeriod = getSelectedPeriod();
  const period_start = processDateJS(selectedPeriod?.period_start)?.format(
    "DD/MM/YYYY",
  );
  const period_end = processDateJS(selectedPeriod?.period_end)?.format(
    "DD/MM/YYYY",
  );

  const fullReportFilename =
    getGroupName() +
    " - Full return draft - " +
    period_start +
    " - " +
    period_end;

  const excelFileName = fullReportFilename + ".xlsx";
  const buffer = await workbook.xlsx.writeBuffer();
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const blob = new Blob([buffer], { type: fileType });
  saveAs(blob, excelFileName);
};
